import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ColumnEmitted, Tree } from '../../../column-picker/models/column-picker';
import { ColumnPickerComponent } from '../../../column-picker/column-picker.component';
import { MatFormField } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { TableType } from '../../../../../../../../models/shipment';

@Component({
  selector: 'app-sorting-item',
  standalone: true,
  templateUrl: './sorting-item.component.html',
  imports: [ColumnPickerComponent, MatFormField, ReactiveFormsModule, MatSelect, MatOption],
  styleUrl: './sorting-item.component.scss'
})
export class SortingItemComponent {
  @Input() sortingGroup!: FormGroup;
  @Input() treeNodes: Tree[] = [];
  @Input() type!: TableType;
  @Output() ruleDeleted = new EventEmitter();

  selectColumn({ key }: ColumnEmitted) {
    this.sortingGroup.get('columnKey')?.setValue(key);
  }
}
